import { FlowStepMessage, MessagingContentHolder } from './MessageContainer.styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const MessageContainer = ({
  layoutType,
  children
}) => {
  return /*#__PURE__*/_jsx(FlowStepMessage, {
    layoutType: layoutType,
    children: /*#__PURE__*/_jsx(MessagingContentHolder, {
      layoutType: layoutType,
      children: children
    })
  });
};